import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { PasswordFieldComponent } from './components/password-field/password-field.component';

const components = [PasswordFieldComponent];

@NgModule({
  imports: [SharedModule],
  declarations: [components],
  exports: [components],
})
export class AuthPrivateModule {}
